import { render, staticRenderFns } from "./MultipleSelect.vue?vue&type=template&id=626c631c&scoped=true&"
import script from "./MultipleSelect.vue?vue&type=script&lang=js&"
export * from "./MultipleSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626c631c",
  null
  
)

export default component.exports